import { call, put, takeLatest } from "redux-saga/effects";
import {
  postFeedbackFailure,
  postFeedbackStart,
  postFeedbackSuccess,
} from "../reducer";
import { networkErrorHandler } from "../../../utils/errorHandlers";
import { httpPostFeedback } from "../../../services/feedback";
import { successNotifier } from "../../../utils/helpers";

function* postFeedback({ payload }) {
  const { data, callback } = payload;
  const response = yield call(httpPostFeedback, data);
  const { success, raw, message } = response;

  if (success) {
    yield put(postFeedbackSuccess(raw));
    successNotifier("Feedback moved to resolved successfully");
    if (callback) {
      callback();
    }
  } else {
    yield put(postFeedbackFailure(message || raw?.error));
    networkErrorHandler(response?.statusCode, message || raw?.error);
  }
}

export default function* onPostFeedback() {
  yield takeLatest(postFeedbackStart, postFeedback);
}
